export default function() {

	const sections = document.querySelectorAll('section');
	const scrollContainer = document.querySelector('.scroll-container');
	const adminBar = document.querySelector('#wpadminbar');

	const bulletClass = 'scroll-progress-outer-bullet';
	const bulletInnerClass = 'inner-bullet';
	const bulletLinesClass = 'bullet-bottom-line';
	const smoothScrollingClass = 'smooth-scrolling';

	let currentSectionIndex = -1;

	if (sections.length > 0 && scrollContainer) {

		// Make bullets for each <section> on the page
		makeScrollContainerBullets();

		const bullets = document.getElementsByClassName(bulletClass);
		const lines = document.getElementsByClassName(bulletLinesClass);

		// Each bullet smooth scrolls to its corresponding section when clicked
		for (let i = 0; i < bullets.length; i++) {

			bullets[i].addEventListener('click', function () {

				// Fix weird case where clicking on a bullet for a previous section (scrolls up), it wouldn't trigger the active status correctly for the section bullet
				sections[i].style.scrollMarginTop = '-1px';

				// Offset admin bar height if needed
				if (!adminBar || window.getComputedStyle(adminBar).display !== 'none') {
					sections[i].style.scrollMarginTop = `-${adminBar.getBoundingClientRect().height + 1}px`;
				}

				document.documentElement.classList.add(smoothScrollingClass);

				// Update the bullets/line heights once it finishes smooth scrolling
				scrollIntoViewAndWait(sections[i]).then(response => {
					updateActiveBullets(currentSectionIndex, bullets);
					updateLineHeight(currentSectionIndex, lines);
					sections[i].style.scrollMarginTop = '';
					document.documentElement.classList.remove(smoothScrollingClass);
				});
			});
		}

		// Update progress line heights on scroll
		window.addEventListener('scroll', () => {

			// Don't spam this while smooth scrolling
			if (!document.documentElement.classList.contains(smoothScrollingClass)) {
				updateActiveBullets(currentSectionIndex, bullets);
				updateLineHeight(currentSectionIndex, lines);
			}
		});

		const observerOptions = {
			root: null,
			// Only trigger when top of screen touches top of section
			rootMargin: '0px 0px -100%',
			threshold: 0,
		};

		const observerCallback = (entries) => {
			entries.forEach(entry => {
				const index = Array.from(sections).indexOf(entry.target);

				// When intersecting with the top of a section, update the current section index as well as the active bullets and progress lines
				if (entry.isIntersecting) {
					currentSectionIndex = index;
					updateActiveBullets(index, bullets);
					updateLineHeight(index, lines);
				}
			});
		};

		// Observe each section
		const observer = new IntersectionObserver(observerCallback, observerOptions);
		sections.forEach(section => observer.observe(section));
	}

	// =================================================================
	// =========================== FUNCTIONS ===========================
	// =================================================================

	/**
	 * Determine if the user is fully scrolled to the bottom of the page
	 *
	 * @return {boolean} {int}
	 */
	function scrolledToBottomOfPage() {

		return document.body.scrollHeight === window.scrollY + window.innerHeight;
	}

	/**
	 * Mark the current section bullet as active, as well as any sections earlier on the page
	 *
	 * @param {int} currentSectionIndex - The index for the current section
	 * @param {HTMLCollection} bullets - The bullet elements
	 */
	function updateActiveBullets(currentSectionIndex, bullets) {

		for (let i = 0; i < bullets.length; i++) {

			// Set the current/previous sections as active (if not scrolled all the way to the top of the page)
			// Or set all sections as active when scrolled all the way to the bottom of the page,
			// which handles cases where the last <section> or the <footer> are too short to fully scroll into and activate
			if ((i <= currentSectionIndex && window.scrollY > 0) || scrolledToBottomOfPage()) {
				bullets[i].classList.add('active');
			} else {
				bullets[i].classList.remove('active');
			}
		}
	}

	/**
	 * Update the line "heights" (background color gradients)
	 *
	 * @param {int} currentSectionIndex - The index for the current section
	 * @param {HTMLCollection} lines - The line elements
	 */
	function updateLineHeight(currentSectionIndex, lines) {
		const rootStyles = getComputedStyle(document.documentElement);
		const progressColor = rootStyles.getPropertyValue('--primary');
		const backgroundColor = rootStyles.getPropertyValue('--tertiary');

		if (currentSectionIndex > -1) {

			for (let i = 0; i < lines.length; i++) {

				// Already past this section, so fill the line
				// Or it is scrolled to the bottom of the page, so mark everything as active
				if (i < currentSectionIndex || scrolledToBottomOfPage()) {
					lines[i].style.background = `linear-gradient(to bottom, ${progressColor} 100%, ${progressColor} 100%)`;
				}
				// Section not visited yet, keep line "empty"
				else if (i > currentSectionIndex) {
					lines[i].style.background = `linear-gradient(to bottom, ${backgroundColor} 100%, ${backgroundColor} 100%)`;
				}
				// Calculate line progress based on scroll progress within the section
				else if (i === currentSectionIndex) {
					const currentSection = sections[currentSectionIndex];
					const sectionTop = currentSection.offsetTop;
					const sectionHeight = currentSection.offsetHeight;
					const sectionProgressPercentage = Math.min((window.scrollY - sectionTop) / sectionHeight, 1) * 100;

					// Default to the current scroll completed percentage within the currently active section
					let sectionProgress = `${sectionProgressPercentage}%`;

					// First section has an extra line, above the first bullet
					if (i === 0) {

						// Offset the extra 15px line at the top of the scroll container
						sectionProgress = `calc(${sectionProgressPercentage}% + 15px)`;

						// At the very top of the page, so remove any scroll progress
						if (window.scrollY === 0) {
							sectionProgress = `0%`;
						}
					}

					lines[i].style.background = `linear-gradient(to bottom, ${progressColor} ${sectionProgress}, ${backgroundColor} ${sectionProgress})`;
				}
			}
		}
	}

	/**
	 * Create the scroll container bullets and lines, one for each <section>
	 */
	function makeScrollContainerBullets() {

		// Add one bullet per <section>
		for (let i = 0; i < sections.length; i++) {

			const bullet = document.createElement('div');
			bullet.classList.add(bulletClass);

			const bulletInner = document.createElement('div');
			bulletInner.classList.add(bulletInnerClass);
			bullet.insertAdjacentElement('beforeend', bulletInner);

			const bulletBottomLine = document.createElement('div');
			bulletBottomLine.classList.add(bulletLinesClass);
			bullet.insertAdjacentElement('beforeend', bulletBottomLine);

			// Add bullet to scroll container
			scrollContainer.insertAdjacentElement('beforeend', bullet);
		}
	}

	/**
	 * Smooth scroll to a section, resolving a promise when the scroll ends
	 *
	 * @param {Element} section - The section to scroll to
	 *
	 * @return {Promise}
	 */
	function scrollIntoViewAndWait(section) {

		return new Promise(resolve => {

			if ('onscrollend' in window) {
				document.addEventListener('scrollend', resolve, {once: true});
				section.scrollIntoView({behavior: 'smooth'});
			} else {
				section.scrollIntoView({behavior: 'smooth'});
				resolve()
			}
		});
	}
}
